import { ZapperAPI, Request } from "@ai360/core";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import { getTheUserGuid } from "~/login/selectors";
import { actions as notificationActions } from "~/notifications";
import { actions, ActionTypes } from "./actions";

function* getAllowedPrompts() {
    try {
        const UserGuid = yield select(getTheUserGuid);
        const requestOptions = { UserGuid, Model: {} };
        const zapperResponse = yield call(
            Request.post,
            ZapperAPI.GET_USER_ANALYZE_ACCESS,
            requestOptions
        );

        yield put(actions.setAllowedPrompts(zapperResponse));
    } catch (e) {
        yield put(notificationActions.apiCallError(e));
    }
}

export const analyzeModuleSaga = function* () {
    yield all([takeEvery(ActionTypes.FETCH_ALLOWED_PROMPTS, getAllowedPrompts)]);
};
